import { CircuitDayFormData } from '@/types/circuits/CircuitDaysFormData';

export const getCircuitSteps = (steps: CircuitDayFormData['steps']) =>
  steps
    .flatMap((CircuitDayStep) => [
      {
        tempId: CircuitDayStep.transport.id,
        standardBenefit: CircuitDayStep.transport.standardBenefit?.id,
        optionalBenefits: CircuitDayStep.transport.optionalBenefits.map(
          (benefit) => benefit.id,
        ),
        standardBenefitDisplays:
          CircuitDayStep.transport.standardDisplays ?? [],
        optionalBenefitsDisplays:
          CircuitDayStep.transport.optionalDisplays ?? [],
        time: CircuitDayStep.transport.time?.value ?? undefined,
        nbDays: CircuitDayStep.transport.nbDays ?? undefined,
        accommodationSelections: undefined,
      },
      {
        tempId: CircuitDayStep.activities.id,
        standardBenefit: CircuitDayStep.activities.standardBenefit?.id,
        optionalBenefits: CircuitDayStep.activities.optionalBenefits.map(
          (benefit) => benefit.id,
        ),
        standardBenefitDisplays:
          CircuitDayStep.activities.standardDisplays ?? [],
        optionalBenefitsDisplays:
          CircuitDayStep.activities.optionalDisplays ?? [],
        time: CircuitDayStep.activities.time?.value ?? undefined,
        accommodationSelections: undefined,
      },
      {
        tempId: CircuitDayStep.meals.id,
        standardBenefit: CircuitDayStep.meals.standardBenefit?.id,
        optionalBenefits: CircuitDayStep.meals.optionalBenefits.map(
          (benefit) => benefit.id,
        ),
        standardBenefitDisplays: CircuitDayStep.meals.standardDisplays ?? [],
        optionalBenefitsDisplays: CircuitDayStep.meals.optionalDisplays ?? [],
        time: CircuitDayStep.meals.time?.value ?? undefined,
        accommodationSelections: undefined,
      },
      {
        tempId: CircuitDayStep.accommodations.id,
        standardBenefit: CircuitDayStep.accommodations.standardBenefit?.id,
        optionalBenefits: CircuitDayStep.accommodations.optionalBenefits.map(
          (benefit) => benefit.id,
        ),
        standardBenefitDisplays:
          CircuitDayStep.accommodations.standardDisplays ?? [],
        optionalBenefitsDisplays:
          CircuitDayStep.accommodations.optionalDisplays ?? [],
        time: CircuitDayStep.accommodations.time?.value ?? undefined,
        nbDays: CircuitDayStep.accommodations.nbDays ?? undefined,
        accommodationSelections: [
          ...(CircuitDayStep.accommodations.standardBenefit &&
          CircuitDayStep.accommodations.standardBenefitPensionType
            ? [
                {
                  benefitId: CircuitDayStep.accommodations.standardBenefit.id,
                  selectionType: 'STANDARD' as const,
                  pensionType:
                    CircuitDayStep.accommodations.standardBenefitPensionType,
                },
              ]
            : []),
          ...CircuitDayStep.accommodations.optionalBenefits
            .map((benefit) => ({
              benefitId: benefit.id,
              selectionType: 'OPTION' as const,
              pensionType:
                CircuitDayStep.accommodations.optionalBenefitsPensionTypes?.[
                  benefit.id
                ],
            }))
            .filter((selection) => Boolean(selection.pensionType)),
        ],
      },
    ])
    .filter((step) => step.standardBenefit || step.optionalBenefits.length);
